module.exports = __webpack_public_path__ + "img/section.5e6a30dd.svg";